import styles from "./TableOfContentsMenu.module.scss";
import { useTableOfContentsItems } from "../../hooks/tableOfContentsHooks/useTableOfContentsItems";
import TableOfContentsList from "./TableOfContentsList";
import { useTableOfContents } from "../../hooks/tableOfContentsHooks/useTableOfContents";
import { useActiveTocItem } from "../../hooks/tableOfContentsHooks/useActiveTocItem";
import PropTypes from "prop-types";

function TableOfContendsModal({ msPath }) {
  useTableOfContentsItems(msPath);
  useActiveTocItem();
  const tocContext = useTableOfContents();

  if (!tocContext.isOpen) return null;

  return (
    <div
      className={styles.modalDialog}
      onClick={(e) => e.stopPropagation()}
      aria-label="Table of Contents Modal"
    >
      <div className={styles.modalHeader}>
        <button
          type="button"
          aria-label="Close Table of Contents"
          className={`${styles.closeButton}`}
          onClick={tocContext.closeModal}
        >
          <i className="tg-icons-Cross"></i>
        </button>
        <h3 className={styles.title}>Contents</h3>
      </div>
      <div className={styles.modalContent}>
        {tocContext.tableOfContents?.children?.length > 0 && (
          <TableOfContentsList items={tocContext.tableOfContents.children} />
        )}
      </div>
    </div>
  );
}

TableOfContendsModal.propTypes = {
  msPath: PropTypes.string.isRequired,
};

export default TableOfContendsModal;
